import { useEffect, useState } from 'react'
import { addMonths, endOfMonth, startOfMonth, subMonths } from 'date-fns'
import type { Range } from 'react-date-range'
import { DateRange } from 'react-date-range'
// @ts-expect-error - @eslint/js is not typed
import * as rdrLocales from 'react-date-range/dist/locale'
import type { DatePickerModalProps } from 'global/types/props'
import { ActionSheet } from 'shared/components/action-sheet'
import { Button } from 'shared/components/button'
import { ButtonColor } from 'global/types/enums'
import { CONSTANT } from 'global/constant'
import { L10N } from 'global/localization'

export const DatePickerModal = ({
  title,
  value,
  open,
  onClose,
  onReset,
  onApply
}: DatePickerModalProps) => {
  const [dates, setDates] = useState<Range[]>([getSelectionDate()])

  useEffect(() => {
    setDates([getSelectionDate(value)])
  }, [value])

  return (
    <ActionSheet title={title} scrollable={false} open={open} onClose={onClose}>
      <DateRange
        locale={localStorage.getItem(CONSTANT.LANGUAGE_KEY) === 'ID' ? rdrLocales.id : undefined}
        className='w-full px-4'
        direction='vertical'
        months={2}
        // color='#002c5f'
        rangeColors={['#002c5f']}
        showDateDisplay={false}
        moveRangeOnFirstSelection={false}
        // showPreview={false}
        monthDisplayFormat={CONSTANT.MONTH_DFNS_FORMAT}
        minDate={startOfMonth(subMonths(new Date(), 11))}
        maxDate={endOfMonth(addMonths(new Date(), 1))}
        scroll={{ enabled: true, monthHeight: 270, longMonthHeight: 270 + 42 }}
        ranges={dates}
        onChange={(item) => setDates([item.selection])}
      />

      <div className='grid grid-cols-2 p-4 gap-4'>
        <Button
          label={L10N.LABEL.RESET}
          color={ButtonColor.WhiteBordered}
          onClick={() => {
            setDates([getSelectionDate()])
            onReset?.()
          }}
        />
        <Button
          label={L10N.LABEL.APPLY}
          color={ButtonColor.Primary}
          onClick={() => onApply?.(getDates(dates))}
        />
      </div>
    </ActionSheet>
  )
}

const getDates = (dateRanges: Range[]): Date[] => {
  const selectionRange = dateRanges.find((range) => range.key === CONSTANT.DATE_RANGE_SELECTION_KEY)

  if (!selectionRange) return []

  return [selectionRange.startDate ?? new Date(), selectionRange.endDate ?? new Date()]
}

const getSelectionDate = (dates?: Date[]) => ({
  startDate: dates?.[0] ?? new Date(),
  endDate: dates?.[1] ?? new Date(),
  key: CONSTANT.DATE_RANGE_SELECTION_KEY
})

export default DatePickerModal
